import { Component, OnInit, TemplateRef } from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormArray,
  FormBuilder,
} from "@angular/forms";
import { Router, Params, ActivatedRoute } from "@angular/router";
import { OutletService } from "./../outlet.service";
import { Outlet } from "./../outlet.model";
import { Observable } from "rxjs/Observable";
import { get } from "lodash";
import { BsModalService } from "ngx-bootstrap";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";

@Component({
  selector: "app-outlet",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class OutletFormComponent implements OnInit {
  public outletForm: FormGroup;

  campaignList: any[];
  regionDatas: Array<any>;
  buDatas: Array<any>;
  countryDatas: Array<any>;
  modalRef: BsModalRef;

  showAlert = false;
  errorMessage: string = null;

  outlet: Outlet = new Outlet();
  isEditing: boolean;
  loading: boolean = false;
  descriptionValidate: boolean = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private outletService: OutletService,
    private modalService: BsModalService,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    this.outletService.hasJustRegistered = false;

    const data = get(this.activatedRoute, ["snapshot", "data"], {});
    this.campaignList = this.getCampagignList().items;
    // @ts-ignore
    this.isEditing = !!data.outlet;
    this.createFormControls();
    this.loading = true;
    this.outletService.getRegionList().subscribe((regions) => {
      this.regionDatas = regions;
      this.outletForm.get("region").setValue(this.regionDatas[0].code);
      this.onChangeRegion(0);
      if (this.isEditing) {
        // @ts-ignore
        this.outlet = data.outlet.data;
        if (this.outlet.hasOwnProperty("id")) {
          this.setChainedOptionsValue();
          this.outletForm.get("id").setValue(this.outlet.id);
          this.outletForm.get("id").disable();
          this.outletForm.get("outletName").setValue(this.outlet.outletName);
          this.outletForm.get("address").setValue(this.outlet.address);
          this.outletForm.get("enabled").setValue(this.outlet.enabled);
          this.outletForm.get("OutletImage").setValue(null);
          this.outletForm.get("OutletRenderImage").setValue(this.outlet.iconUrl);
          this.outlet.campaignList.forEach((campaign) => {
            const curCampaign = this.campaignList.find(
              ({ campaignId }) => campaignId === campaign.campaignId
            );
            const newCampaign: FormGroup = this.fb.group({
              randowId: [campaign.campaignId, [Validators.required]],
              campaignId: [campaign.campaignId, [Validators.required]],
              campaignName: [curCampaign.campaignName, [Validators.required]],
              country: [curCampaign.campaignMainCountry],
              campaignStartDate: [
                curCampaign.campaignStartDt
                  ? this.getLocalDate(curCampaign.campaignStartDt * 1000)
                  : null,
              ],
              campaignEndDate: [
                curCampaign.campaignEndDt
                  ? this.getLocalDate(curCampaign.campaignEndDt * 1000)
                  : null,
              ],
            });
            this.campaignIdsObjArr.push(newCampaign);
          });
          this.loading = false;
        } else {
          this.router.navigate(["/outlet"]);
        }
      } else {
        this.loading = false;
      }
    });
  }

  createFormControls() {
    this.outletForm = this.fb.group({
      id: [null],
      outletName: [null, [Validators.required]],
      enabled: [true, [Validators.required]],
      region: [null, [Validators.required]],
      operatingUnit: [null, [Validators.required]],
      country: [null, [Validators.required]],
      address: [null, [Validators.required]],
      OutletImage: [null],
      OutletRenderImage: [''],
      campaignIdsObjArr: this.fb.array([]),
    });
  }
  onFileSelected(event) {  
    this.loading = true;
    const curFile = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = (e) => {
      const base64String = reader.result as string;
      const params:any = {
        fileName: curFile.name,
        fileContent: base64String.split(',')[1],
        contentType: curFile.type,
      }
      this.outletService.uploadImage(params).subscribe(res => {
        if (res) {
          this.outletForm.get("OutletRenderImage").setValue(res.data)
        }
      })
      // 将base64String发送到服务器
    };
    reader.readAsDataURL(curFile)
  }
  onImageLoad() {
    this.loading = false;
  }

  deleteImage(){
    this.outletForm.get("OutletRenderImage").setValue('')
    this.outletForm.get("OutletImage").setValue(null)
  }
  setChainedOptionsValue() {
    this.outletForm.get("region").setValue(this.outlet.region);
    this.outletForm.get("operatingUnit").setValue(this.outlet.operatingUnit);
    this.outletForm.get("country").setValue(this.outlet.country);
    this.regionDatas.forEach((region, index) => {
      if (region.code == this.outlet.region) {
        this.buDatas = this.regionDatas[index].bu;
        this.buDatas.forEach((bu, buIndex) => {
          if (bu.code == this.outlet.operatingUnit) {
            this.countryDatas = this.buDatas[buIndex].country;
          }
        });
      }
    });
  }

  onChangeRegion(regionIndex: any) {
    this.buDatas = this.regionDatas[regionIndex].bu;
    this.outletForm.get("operatingUnit").setValue(this.buDatas[0].code);
    this.onChangeBu(0);
  }

  onChangeBu(buIndex: number) {
    this.countryDatas = this.buDatas[buIndex].country;
    this.outletForm.get("country").setValue(this.countryDatas[0].code);
    this.onChangeCountry(0);
  }

  onChangeCountry(countryIndex: number) {}

  private getCampagignList(): any {
    const filterBefore = get(this.activatedRoute, ["snapshot", "data", "campaigns"], []);
    return {...filterBefore, items: filterBefore.items.filter(item => item.onlyDash === 'true')}
  }

  errorMessageClose(): void {
    this.showAlert = false;
    this.errorMessage = "";
  }

  private dirtyForm(form: FormGroup | FormArray) {
    if (form instanceof FormGroup) {
      Object.keys(form.controls).forEach((key) => {
        const control = form.controls[key];

        if (control instanceof FormGroup || control instanceof FormArray) {
          return this.dirtyForm(control);
        }

        control.markAsDirty();
      });
    }
    if (form instanceof FormArray) {
      form.controls.forEach((c) => {
        return this.dirtyForm(c as FormGroup);
      });
    }
  }

  checkInputValue(e: any) {
    return this.outletForm.get(e.target.id).setValue(e.target.value);
  }

  get campaignIdsObjArr(): FormArray {
    return this.outletForm.get("campaignIdsObjArr") as FormArray;
  }

  addCampaign() {
    const newCampaign: FormGroup = this.fb.group({
      randowId: [Date.now(), [Validators.required]],
      campaignId: [null, [Validators.required]],
      campaignName: [null, [Validators.required]],
      country: [null],
      campaignStartDate: [null],
      campaignEndDate: [null],
    });
    this.campaignIdsObjArr.push(newCampaign);
  }

  outletSubmit(template: TemplateRef<any>): any {
    this.dirtyForm(this.outletForm);

    const outlet: any = {
      outletName: this.outletForm.get("outletName").value,
      region: this.outletForm.get("region").value,
      operatingUnit: this.outletForm.get("operatingUnit").value,
      country: this.outletForm.get("country").value,
      address: this.outletForm.get("address").value,
      enabled: this.outletForm.get("enabled").value,
      iconUrl: this.outletForm.get("OutletRenderImage").value
    };
    if (this.campaignIdsObjArr.value.length > 0) {
      outlet.campaignIds = this.campaignIdsObjArr.value.map(
        ({ campaignId }) => campaignId
      );
    }
    if (this.outletForm.valid) {
      this.loading = true;
      if (!this.isEditing) {
        this.outletService.saveOutlet(outlet).subscribe(
          (res) => {
            this.loading = false;
            this.modalRef = this.modalService.show(template, {
              ignoreBackdropClick: true,
            });
          },
          (error) => {
            this.loading = false;
            this.showAlert = true;
            this.errorMessage = error;
          }
        );
      } else {
        this.activatedRoute.params.subscribe((value) => {
          outlet.id = value.outletId;
        });
        this.outletService.updateOutlet(outlet).subscribe(
          (res) => {
            this.loading = false;
            this.router.navigate(["/outlet"]);
          },
          (error) => {
            this.loading = false;
            this.showAlert = true;
            this.errorMessage = error;
          }
        );
      }
    }
  }

  deleteCampaign(i) {
    this.campaignIdsObjArr.removeAt(i);
  }
  verifiData(data, i) {
    const formArray = this.outletForm.get("campaignIdsObjArr") as FormArray;
    const formGroup = formArray.at(i) as FormGroup;
    const campaignId = formGroup.get("campaignId") as FormControl;
    const country = formGroup.get("country") as FormControl;
    const campaignStartDate = formGroup.get("campaignStartDate") as FormControl;
    const campaignEndDate = formGroup.get("campaignEndDate") as FormControl;
    const {
      campaignName: { value },
    } = data.controls;
    if (value) {
      this.campaignList = this.getCampagignList().items.filter(
        ({ campaignName }) =>
          campaignName.toLowerCase().includes(value.toLowerCase())
      );
      const curRealCampagign = this.getCampagignList().items.find(
        ({ campaignName }) => campaignName.toLowerCase() === value.toLowerCase()
      );
      if (curRealCampagign) {
        campaignId.setValue(curRealCampagign.campaignId);
        country.setValue(curRealCampagign.campaignMainCountry);
        campaignStartDate.setValue(
          curRealCampagign.campaignStartDt
            ? this.getLocalDate(curRealCampagign.campaignStartDt * 1000)
            : null
        );
        campaignEndDate.setValue(
          curRealCampagign.campaignEndDt
            ? this.getLocalDate(curRealCampagign.campaignEndDt * 1000)
            : null
        );
      } else {
        campaignId.setValue(null);
        country.setValue(null);
        campaignStartDate.setValue(null);
        campaignEndDate.setValue(null);
      }
    } else {
      this.campaignList = this.getCampagignList().items;
      campaignId.setValue(null);
      country.setValue(null);
      campaignStartDate.setValue(null);
      campaignEndDate.setValue(null);
    }
  }
  focus(data) {
    const {
      campaignName: { value },
    } = data.controls;
    if (value) {
      this.campaignList = this.getCampagignList().items.filter(
        ({ campaignName }) =>
          campaignName.toLowerCase().includes(value.toLowerCase())
      );
    } else {
      this.campaignList = this.getCampagignList().items;
    }
  }

  redirectTo(uri: string) {
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }

  getLocalDate(time) {
    let date = new Date(time);
    return date.toLocaleDateString();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/outlet/form/form.component.ts